import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useProjectsList } from '../../../../../contexts/ProjectsContext';
import { useForm } from 'react-hook-form';
import { setActiveTab } from '../../../../../uiSlice';
import CommonTaskTable from './CommonTaskTable';
import IndependentTaskTable from './IndependentTaskTable';
import GroupTaskTable from './GroupTaskTable';

const subTabs = [
  { key: 'commonTask', label: 'Common Task' },
  { key: 'independentAccommodation', label: 'Independent Task (Accommodation)' },
  { key: 'groupAccommodation', label: 'Group Task (Accommodation)' }
];

const liveTasksTabBySubTab = {
  commonTask: 'commonTasks',
  independentAccommodation: 'independentAccommodation',
  groupAccommodation: 'groupAccommodation'
};

const MyTask = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeSubTab, setActiveSubTab] = useState('commonTask');
  const { projects, projectsForDropdown } = useProjectsList();
  const { register, watch, setValue } = useForm();

  const selectedProject = watch('project');

  useEffect(() => {
    if (projects?.length) {
      const projectId = location.state?.projectID || projects[0].id;
      setValue('project', projectId);
    }
  }, [projects, location.state?.projectID, setValue]);

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'commonTask':
        return <CommonTaskTable projectId={selectedProject} />;
      case 'independentAccommodation':
        return <IndependentTaskTable projectId={selectedProject} />;
      case 'groupAccommodation':
        return <GroupTaskTable projectId={selectedProject} />;
      default:
        return <CommonTaskTable projectId={selectedProject} />;
    }
  };

  return (
    <div>
      <div className="py-2 sticky top-[4.1rem] z-20 bg-white px-6 border-t border-b border-gray-200 shadow-sm flex items-center justify-between">
        <div className="flex items-center gap-6 px-6">
          {subTabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveSubTab(tab.key)}
              className={`py-3 text-sm font-semibold transition-colors duration-200 relative leading-none ${
                activeSubTab === tab.key ? 'text-[#2A565E]' : 'text-gray-400 hover:text-gray-600'
              }`}>
              {tab.label}
              {activeSubTab === tab.key && (
                <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#2A565E] transition-all duration-300" />
              )}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-3 shrink-0 self-center">
          <button
            type="button"
            onClick={() => {
              dispatch(setActiveTab(liveTasksTabBySubTab[activeSubTab]));
              navigate('/builder/operations/tasks');
            }}
            className="inline-flex h-9 items-center justify-center px-4 rounded-[8px] text-sm font-medium bg-[#2A565E] text-white border border-[#2A565E] transition-all duration-200 hover:opacity-95 leading-none">
            Create
          </button>
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-gray-500 whitespace-nowrap leading-none">
              Project :
            </span>
            <select
              className="h-9 w-[min(240px,40vw)] px-2 border border-stone-300 rounded text-sm text-gray-800 bg-white leading-none"
              {...register('project', { required: true })}>
              <option value="" disabled>
                Select Project
              </option>
              {projectsForDropdown.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="p-6">{renderSubTabContent()}</div>
    </div>
  );
};

export default MyTask;
